import React, { useEffect, useState } from 'react';
import { PlayIcon } from '../Icons/PlayIcon';
import { PauseIcon } from '../Icons/PauseIcon';
import { PrevIcon } from '../Icons/PrevIcon';
import { NextIcon } from '../Icons/NextIcon';
import { PlaybackRateButton } from '../Header/PlaybackRateButton';
import { EditorModeEnums, IStore } from '../../redux/store/IStore';
import '../../styles/css/header.css';
import Grid from '@mui/material/Grid';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { setClickedTime } from '../../redux/features/app/app';

interface IProps {
  audioIsPlaying: boolean;
  playbackRate: number;
  audioCanPlay: boolean;
  handlePlayBackRate: () => void;
  handlePlaybackRateLower: () => void;
  handlePlaybackRateHigher: () => void;
  togglePlayPause: (e: React.SyntheticEvent) => void;
  handleDynamicPlaybackRate: (playbackRate: number) => void;
}

const AudioControls = ({
  audioIsPlaying,
  playbackRate,
  handleDynamicPlaybackRate,
  handlePlaybackRateLower,
  handlePlaybackRateHigher,
  togglePlayPause,
}: IProps) => {
  const [playMode, setPlayMode] = useState<boolean>(false);

  const dispatch = useAppDispatch();
  const editorMode = useAppSelector(state => state.app.editorMode);
  const currentTime = useAppSelector(state => state.app.currentTime);

  useEffect(() => {
    if (audioIsPlaying) {
      setPlayMode(true);
    }
  }, [audioIsPlaying]);

  const handleForwardClick = () => {
    if (editorMode === EditorModeEnums.PLAYING_MODE) {
      dispatch(setClickedTime(currentTime + 5));
    }
  };

  const handleBackwardClick = () => {
    if (editorMode === EditorModeEnums.PLAYING_MODE) {
      if (currentTime - 5 <= 0) {
        dispatch(setClickedTime(0));
      }
      dispatch(setClickedTime(currentTime - 5));
    }
  };

  return (
    <Grid item>
      <Grid container alignItems="center" spacing={1}>
        <Grid item>
          <button onClick={togglePlayPause}>
            {audioIsPlaying ? (
              <PauseIcon
                className="icon_button"
                viewBox="0 0 48 48"
                style={{
                  fill: '#2B8DFF',
                }}
              />
            ) : (
              <PlayIcon
                className="icon_button"
                viewBox="0 0 48 48"
                style={{
                  fill: playMode ? '#2B8DFF' : '#ccc',
                }}
              />
            )}
          </button>
        </Grid>
        <Grid item>
          <PlaybackRateButton
            handleDynamicPlaybackRate={handleDynamicPlaybackRate}
            playbackRatio={playbackRate}
            handlePlaybackRateLower={handlePlaybackRateLower}
            handlePlaybackRateHigher={handlePlaybackRateHigher}
          />
        </Grid>
        <Grid item>
          <button onClick={handleBackwardClick}>
            <PrevIcon className="icon_button" viewBox="0 0 48 48" />
          </button>
        </Grid>
        <Grid item>
          <button onClick={handleForwardClick}>
            <NextIcon className="icon_button" viewBox="0 0 48 48" />
          </button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AudioControls;
